import { selectors } from 'publisher/reducers/paymentReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function usePayment(selector) {
  return useSelector(state => selector(state.payment), shallowEqual)
}
